"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var PaymentStyles_1 = require("./PaymentStyles");
var paymentApi_1 = require("../../../../common/api/paymentApi");
var useAppContext_1 = require("../../../../common/react/useAppContext");
var DefaultText_1 = require("../../staticText/DefaultText");
var TransactionErrorTypes_1 = require("../../../../common/enum/TransactionErrorTypes");
var useDealErrorHandler_1 = require("../../../../common/react/useDealErrorHandler");
var useDealStatusAssertion_1 = require("../../../../common/react/useDealStatusAssertion");
var JourneyTypes_1 = require("../../../../../../common/enum/JourneyTypes");
var errorMessageHoc_1 = require("../../../../common/components/presentation/Error/errorMessageHoc");
var MinimalLoader_1 = require("../../../../common/components/presentation/MinimalLoader/MinimalLoader");
var react_intl_1 = require("react-intl");
var VisaLogo_1 = require("../../../../common/assets/creditCardLogos/VisaLogo");
var MasterCardLogo_1 = require("../../../../common/assets/creditCardLogos/MasterCardLogo");
var clsx_1 = require("clsx");
var PaymentErrorText_1 = require("../../staticText/PaymentErrorText");
var ApexxPaymentForm = function (_a) {
    var _b;
    var componentHandleError = _a.componentHandleError;
    var style = PaymentStyles_1.default();
    var intl = react_intl_1.useIntl();
    var transactionError = useAppContext_1.default().transactionError;
    var handleDealError = useDealErrorHandler_1.default();
    var parentNodeId = react_1.useState('wrapper:checkout:paymentProvider')[0];
    var _c = react_1.useState(null), paymentData = _c[0], setPaymentData = _c[1];
    var _d = react_1.useState(true), isLoading = _d[0], setIsLoading = _d[1];
    var initializePaymentForm = function () { return __awaiter(void 0, void 0, void 0, function () {
        var paymentAccessCode, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, paymentApi_1.default.getAccessCode()];
                case 2:
                    paymentAccessCode = _a.sent();
                    setPaymentData(paymentAccessCode.data);
                    window.addEventListener('message', function (event) {
                        if ('apexxRedirect' === event.data.name) {
                            window.location.href = event.data.redirectUrl;
                        }
                    });
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    componentHandleError(handleDealError(error_1));
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var cleanIframe = function () {
        var iframe = document.getElementsByTagName('iframe');
        if (iframe.length) {
            iframe[0].parentNode.removeChild(iframe[0]);
        }
    };
    useDealStatusAssertion_1.default((_b = {},
        _b[JourneyTypes_1.JourneyTypes.RESERVE_ONLINE] = 3100,
        _b[JourneyTypes_1.JourneyTypes.CONTINUE_IN_DEALERSHIP] = false,
        _b[JourneyTypes_1.JourneyTypes.ORDER_ONLINE] = false,
        _b));
    react_1.useEffect(function () {
        initializePaymentForm();
        return function () { return cleanIframe(); };
    }, []);
    react_1.useEffect(function () {
        var _a;
        if (paymentData) {
            var viewport = document.querySelector('meta[name=viewport]');
            // Fix for ios auto zoom on input focus
            (_a = viewport) === null || _a === void 0 ? void 0 : _a.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0');
        }
    }, [paymentData]);
    if (isLoading) {
        return (<core_1.Box display="flex" justifyContent="center">
        <MinimalLoader_1.default />
      </core_1.Box>);
    }
    return (<>
      {transactionError === TransactionErrorTypes_1.TransactionErrorTypes.FAILED ? (<PaymentErrorText_1.default style={style}/>) : (<DefaultText_1.default paymentData={paymentData} style={style}/>)}
      <core_1.Box data-test={parentNodeId} className={style.container}>
        <core_1.Box className={style.formHeader}>
          <core_1.Box className={style.headerItem}>
            <core_1.Typography>
              <react_intl_1.FormattedMessage id="payment.form.header" defaultMessage=" "/>
            </core_1.Typography>
          </core_1.Box>
          <core_1.Box className={clsx_1.default(style.headerItem, style.logosWrapper)}>
            <core_1.Box display="flex">
              <VisaLogo_1.default />
            </core_1.Box>
            <core_1.Box display="flex">
              <MasterCardLogo_1.default />
            </core_1.Box>
          </core_1.Box>
        </core_1.Box>
        <iframe src={paymentData.url}/>
      </core_1.Box>
      <core_1.Box className={style.disclaimersContainer}>
        <core_1.Typography>
          <react_intl_1.FormattedMessage id="payment.mandatoryFields" values={{
        phoneNumber: (<a href={"tel:" + intl.formatMessage({ id: 'payment.phoneNumber' })}>
                  <react_intl_1.FormattedMessage id="payment.phoneNumber" defaultMessage=" "/>
                </a>),
        email: (<a href={"mailto:" + intl.formatMessage({ id: 'payment.email' })}>
                  <react_intl_1.FormattedMessage id="payment.email" defaultMessage=" "/>
                </a>),
        disclaimerLink: (<a href={intl.formatMessage({ id: 'payment.disclaimerLink' })} target={'_blank'} rel="noreferrer">
                  <react_intl_1.FormattedMessage id="payment.disclaimerLink" defaultMessage=" "/>
                </a>),
    }}/>
        </core_1.Typography>
      </core_1.Box>
    </>);
};
exports.default = errorMessageHoc_1.default(ApexxPaymentForm);
